export default "__VITE_ASSET__96140085__"